import CSSModules from 'react-css-modules';
import { IntlProvider, injectIntl, intlShape } from 'react-intl';

import { SettingsProvider } from './settings';
import getDisplayName from './get-component-display-name';


export function WixConnect(styles) {
  return function (WrappedComponent) {

    if (styles) {
      WrappedComponent = CSSModules(styles, {
        allowMultiple: true,
        errorWhenNotFound: false,
      })(WrappedComponent);
    }

    @injectIntl
    class ConnectWixStuff extends React.Component {

      static displayName = `ConnectWixStuff(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        appSettings: React.PropTypes.object,
        intl: intlShape,
      };

      static contextTypes = {
        appSettings: React.PropTypes.object,
      };

      render() {
        const { appSettings } = this.context;
        const { intl, appSettings: propsSettings } = this.props;

        const props = _.assign({}, this.props, {
          appSettings: propsSettings || appSettings,
          intl,
        });

        return <WrappedComponent {...props} />;
      }
    }

    return ConnectWixStuff;
  };
}


const DEFAULT_LOCALE = 'en';
const loadTranslations = locale => require(`widget/player-widget/translations/widget-texts_${locale}.json`);
const defaultTranslations = loadTranslations(DEFAULT_LOCALE);

export function WixProvide(WrappedComponent) {
  class ProvideWixStuff extends React.Component {

    static displayName = `Settings(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      appSettings: React.PropTypes.object,
      locale: React.PropTypes.string,
      translations: React.PropTypes.object,
    };

    static childContextTypes = {
      appSettings: React.PropTypes.object,
      locale: React.PropTypes.string,
      translations: React.PropTypes.object,
    };

    static defaultProps = {
      locale: DEFAULT_LOCALE,
      translations: {},
    };

    getChildContext() {
      const { appSettings, locale } = this.props;
      const { translations } = this;

      return {
        appSettings,
        locale,
        translations,
      };
    }

    componentWillMount() {
      const { locale, translations } = this.props;

      let loadedTranslations;
      try {
        loadedTranslations = loadTranslations(locale);
      } catch (error) {
        loadedTranslations = {};
      }

      this.translations = { ...this.translations, ...loadedTranslations, ...translations };
    }

    translations = defaultTranslations;

    render() {
      const { appSettings, locale, ...childrenProps } = this.props;
      const { translations } = this;

      return (
        <SettingsProvider appSettings={appSettings}>
          <IntlProvider locale={locale}
                        messages={translations}>
            <WrappedComponent {...childrenProps} />
          </IntlProvider>
        </SettingsProvider>
      );
    }
  }

  return ProvideWixStuff;
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/wix-connect.js